export const SET_LOGIN = 'SET_LOGIN';
export const SET_USERID = 'SET_USERID';
export const SET_USERNAME = 'SET_USERNAME';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_LASTNAME = 'SET_LASTNAME';
